import {callAPI} from '@/store/utils'; // eslint-disable-line

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    banksCounter: 0,
    employeesCounter: 0,
    countriesList: [],
  },
  mutations: {
    setStats(state, data) {
      state.banksCounter = data.banks;
      state.employeesCounter = data.employees;
    },
    setCountries(state, data) {
      state.countriesList = data;
    },
  },
  actions: {
    async actionGetHeaders(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getHeaders', {...params, companyId});
      return res;
    },
    async actionAddManualTransactions(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'addManualTransactions',
        {...params, companyId},
        false,
        120,
        0,
      );
      return res;
    },
    async actionGetCountries({commit}) {
      const res = await callAPI('POST', 'getCountriesList', {});
      if (res && res.result && res.result.length) {
        commit('setCountries', res.result);
      }
      return res.result;
    },
    async actionUpdateBillingInformation(_, params) {
      const res = await callAPI('POST', 'updateBillingInformation', params);
      return res.result;
    },
    async actionGetBillingInfo(_, params) {
      const res = await callAPI('POST', 'getBillingInfo', params);
      return res.result;
    },
    async actionGetPaymentMethodInfo(_, params) {
      const res = await callAPI('POST', 'getPaymentMethodInfo', params);
      return res.result;
    },
    async actionGetAllInvoices(_, params) {
      const res = await callAPI('POST', 'getAllInvoices', params);
      return res.result;
    },
    async actionApplyForCoupons(_, params) {
      const res = await callAPI('POST', 'applyForCoupons', params);
      return res.result;
    },
    async actionRemoveCoupons(_, params) {
      const res = await callAPI('POST', 'removeCoupons', params);
      return res;
    },
    async actionGetPlanListing(_, params) {
      return await callAPI('POST', 'getPlanListing', params);
    },
    async actionGetCurrentBasePlan(_, params) {
      const res = await callAPI('POST', 'getCurrentBasePlan', params);
      return res.result;
    },
    async actionGetStripeCheckoutSession(_, params) {
      const res = await callAPI('POST', 'get_stripe_checkout_session', params);
      return res.result;
    },
    async actionCreateSubscription({dispatch}, params) {
      const res = await callAPI('POST', 'create_subscription', params);
      await dispatch(
        'subscription/actionGetSubscriptionForCompany',
        {},
        {root: true},
      );
      return res;
    },
    async actionUpdateSubscription({dispatch}, params) {
      const res = await callAPI('POST', 'update_subscription', params);
      await dispatch(
        'subscription/actionGetSubscriptionForCompany',
        {},
        {root: true},
      );
      return res.result;
    },
    async actionGetCurrentCoupons(_, params) {
      const res = await callAPI('POST', 'getCurrentCoupons', params);
      return res.result;
    },
    async actionGetCompanyStats({commit}, params) {
      const res = await callAPI('POST', 'getCompanyStats', params);
      if (res && res.result) {
        commit('setStats', res.result);
      }
    },
    async actionDeletePaymentMethod(_, params) {
      const res = await callAPI('POST', 'deletePaymentMethod', params);
      return res.result;
    },
  },
};
